<template>
  <div>
    <div class="mobile">
      <div class="header">
        <div class="title">
          骆驼测保—500万用户信赖，专注保险测评
        </div>
        <div class="tags">
          <div class="date">
            骆驼测保-专心保险经纪
          </div>
        </div>
      </div>
      <div class="content">
        <div class="qrcode">
          <img src="@/assets/images/directadd/qrcode.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DaRes",

  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.mobile {
  background: rgba(255, 255, 255, 1);
  margin: 24px 20px;
  min-height: 100%;
  .header {
    text-align: left;
    height: auto !important;
    .title {
      font-size: 20px;
      font-family: PingFangSCBold;
      color: #2b3854;
      line-height: 29px;
    }
    .tags {
      display: flex;
      margin-top: 8px;
      align-content: center;

      div + div {
        margin-left: 14px;
      }
      .date {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
      }
    }
  }
  .content {
    margin-top: 30px;
    height: 496px;
    background-image: url("~@/assets/images/directadd/qrcode-bg.png");
    background-size: 100% 100%;
    position: relative;
    .qrcode {
      width: 165px;
      height: 165px;
      position: absolute;
      left: 50%;
      margin-left: -83px;
      top: 110px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
